import { Button } from "@kanda-libs/ks-design-library";
import type { FunctionComponent } from "react";
import JobRevertModal from "components/job/JobRevertModal";
import JobRevertButtonContainer from "components/job/JobRevertButton/JobRevertButtonContainer";
import useJobRevertButtonProps from "components/job/JobRevertButton/useJobRevertButtonProps";

export interface JobRevertButtonProps {}

const JobRevertButton: FunctionComponent<JobRevertButtonProps> = function () {
  const { onClick } = useJobRevertButtonProps();

  return (
    <JobRevertButtonContainer>
      <>
        <Button.Text
          id="staff-revert-job"
          label="Revert Job"
          size={40}
          className="ml-4 warning-button"
          onClick={onClick}
        />
        <JobRevertModal />
      </>
    </JobRevertButtonContainer>
  );
};

export default JobRevertButton;
